import React, {useEffect, useState} from 'react';

export function InputDebounceUserForm({error, type, placeholder = '', name, value, disabled, onChange}) {
  const [current, setCurrent] = useState(value || '');

  useEffect(() => {
    if (current === value) {
      return;
    }
    const tm = setTimeout(() => {
      onChange(name, current)
    }, 500);

    return () => clearTimeout(tm);
  }, [current, name, value, onChange]);

  return <input type={type}
                name={name}
                className={"tabs__input input" + (error ? " input--error" : "")}
                placeholder={placeholder}
                value={current}
                disabled={disabled}
                onChange={(e) => setCurrent(e.target.value)}/>;
}
